import { z } from "zod";

export const orderItemSchema = z.object({
  name: z.string(),
  quantity: z.number(),
  uom: z.string(),
  currency: z.string().optional(),
  amount: z.number().optional(),
});

export const orderInfoSchema = z.object({
  source_of_order: z
    .enum(["whatsapp", "email", "kaso", "supy", "watermelon"])
    .optional(),
  ordering_company: z.string().optional(),
  po_number: z.string().nullable().optional(),
  order_date: z.string().optional(),
  expected_delivery_date: z.string().nullable().optional(),
  delivery_address: z.string().optional(),
  items_ordered: z.array(orderItemSchema).optional(),
  orderer_email: z.string().optional(),
  vendor_company: z.string().optional(),
});

export const uploadRequestFileSchema = z.object({
  id: z.string(),
  order_id: z.string().nullable().optional().default(""),
  storage_path: z.string(),
  original_name: z.string(),
  mime_type: z.string().nullable().optional().default(""),
  category: z.string(),
  status: z.string(),
  error_message: z.string().nullable().optional().default(""),
  llm_response: orderInfoSchema.nullable().optional().default(null),
  aggregated_items: z.array(orderItemSchema).optional().default([]),
  processed_at: z.string().nullable().optional(),
  uploaded_at: z.string().nullable().optional(),
});

export const uploadRequestSchema = z.object({
  id: z.string(),
  status: z.string(),
  files: z.array(uploadRequestFileSchema).default([]),
  summary: z.string().nullable().optional(),
  aggregated_payload: z.array(z.any()).default([]),
  error_message: z.string().nullable().optional(),
  llm_model: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type OrderItem = z.infer<typeof orderItemSchema>;
export type OrderInfo = z.infer<typeof orderInfoSchema>;
export type UploadRequest = z.infer<typeof uploadRequestSchema>;
export type UploadRequestFile = z.infer<typeof uploadRequestFileSchema>;

export const uploadFileConfirmPayloadSchema = z.object({
  order: z.record(z.any()).optional(),
});

export const uploadFileConfirmResponseSchema = z.object({
  detail: z.string(),
  task_id: z.string(),
  file_id: z.string(),
});

export const uploadBulkConfirmOverrideSchema = z.object({
  file_id: z.string(),
  order: z.record(z.any()).optional(),
});

export const uploadBulkConfirmPayloadSchema = z.object({
  files: z.array(uploadBulkConfirmOverrideSchema).optional(),
});

export const uploadBulkConfirmResponseSchema = z.object({
  detail: z.string(),
  task_id: z.string(),
});

export type UploadFileConfirmPayload = z.infer<
  typeof uploadFileConfirmPayloadSchema
>;
export type UploadFileConfirmResponse = z.infer<
  typeof uploadFileConfirmResponseSchema
>;
export type UploadBulkConfirmOverride = z.infer<
  typeof uploadBulkConfirmOverrideSchema
>;
export type UploadBulkConfirmPayload = z.infer<
  typeof uploadBulkConfirmPayloadSchema
>;
export type UploadBulkConfirmResponse = z.infer<
  typeof uploadBulkConfirmResponseSchema
>;
